import { END_POINT } from '../end-point';
import { httpService } from '../util/axiosRequests';
import { getAccessTokenFromCookies } from 'lib/utils/setTokensInCookies';

const visitRequestAPI = {
  // 내방신청 기초정보 가져오기 API
  async getVisitRequestBasicAPI(): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(END_POINT.visitRequestController.getVisitRequestBasic(), {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getVisitRequestBasicAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getVisitRequestBasicAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },

  // 담당자 조회 API
  async getVisitRequestManagersAPI(email: string): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(`${END_POINT.visitRequestController.getVisitRequestManagers()}?email=${email}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getVisitRequestManagersAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getVisitRequestManagersAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },

  // 내방신청 내역 조회 API
  async getVisitRequestHistoryAPI(params: {
    visitFrom: string;
    visitTo: string;
    managerName: string | null;
    status: string | null;
    page: number;
  }): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(`${END_POINT.visitRequestController.getVisitRequestHistory()}`, {
        params, // params 객체를 직접 전달
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getVisitRequestAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getVisitRequestAPI 조회 실패 :', error);
      console.error(error);
      throw error;
    }
  },
  // 내방신청 저장
  postVisitRequestAPI: async (data: any) => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('postVisitRequestAPI 호출', accessToken);
    try {
      // console.log('내방신청 저장 : postVisitRequestAPI id data: ', data);
      const response = await httpService.post<any>(END_POINT.visitRequestController.postVisitRequest(), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // Bearer 형식으로 Authorization 헤더에 추가
        }
      });
      // console.log('내방신청 저장 : postVisitRequestAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('postVisitRequestAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  async getVisitRequestIdAPI(id: number): Promise<any> {
    const accessToken = getAccessTokenFromCookies();
    try {
      const response: any = await httpService.get(`${END_POINT.visitRequestController.getVisitRequestId(id)}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}` // headers에 accessToken 첨부
        }
      });
      // console.log('getVisitRequestIdAPI 조회 성공: ', response);
      return response.data;
    } catch (error) {
      // console.error('getVisitRequestIdAPI 조회 실패 :', error);
      console.error(error);
      return (error as { data: { code: 0; data: null } }).data;
    }
  },

  // 내방신청 변경
  putVisitRequestIdAPI: async (id: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('putVisitRequestIdAPI 호출', accessToken);
    try {
      // console.log('내방신청 변경 : putVisitRequestIdAPI id, data : ', id, data);
      const response = await httpService.put<any>(END_POINT.visitRequestController.putVisitRequestId(id), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      // console.log('내방신청 변경 : putVisitRequestIdAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('putVisitRequestIdAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 내방신청 승인
  putVisitRequestApproveIdAPI: async (id: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('putVisitRequestApproveIdAPI 호출', accessToken);
    try {
      // console.log('내방신청 승인 : putVisitRequestApproveIdAPI id : ', id);
      const response = await httpService.put<any>(END_POINT.visitRequestController.putVisitRequestApproveId(id), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      // console.log('내방신청 승인 : putVisitRequestApproveIdAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('putVisitRequestApproveIdAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 내방신청 취소
  putVisitRequestCancelIdAPI: async (id: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('putVisitRequestCancelIdAPI 호출', accessToken);
    try {
      // console.log('내방신청 취소 : putVisitRequestCancleIdAPI id : ', id);
      const response = await httpService.put<any>(END_POINT.visitRequestController.putVisitRequestCancelId(id), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      // console.log('내방신청 취소 : putVisitRequestCancelIdAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('putVisitRequestCancelIdAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },
  // 내방신청 반려
  putVisitRequestRejectedIdAPI: async (id: number, data: any) => {
    const accessToken = getAccessTokenFromCookies();
    // console.log('putVisitRequestRejectedIdAPI 호출', accessToken);
    try {
      // console.log('내방신청 반려 : putVisitRequestRejectedIdAPI id, data : ', id, data);
      const response = await httpService.put<any>(END_POINT.visitRequestController.putVisitRequestRejectedId(id), data, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer 형식으로 Authorization 헤더에 추가
          Accept: 'application/json' // 필요에 따라 Accept 헤더 추가 가능
        }
      });
      // console.log('내방신청 반려 : putVisitRequestRejectedIdAPI res data: ', response);
      return response;
    } catch (error) {
      // console.error('putVisitRequestRejectedIdAPI 호출 중 오류 발생:', error);
      console.error(error);
      throw error;
    }
  },

  // 오픈된 내방신청 승인/반려
  async getVisitRequestActionPublicAPI(action: string, token: string, user: number): Promise<any> {
    try {
      const response: any = await httpService.get(`${END_POINT.visitRequestController.getVisitRequestActionPublic(action, token, user)}`, {
        withCredentials: false
      });
      return response.data;
    } catch (error) {
      return (error as { data: { code: 0; data: null } }).data;
    }
  },

  // 승인 목록 메일 전송
  async getSendApprovedVisitorListAPI(): Promise<any> {
    try {
      const accessToken = getAccessTokenFromCookies();
      const response: any = await httpService.get(`${END_POINT.visitRequestController.getSendApprovedVisitorList()}`, {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      return response.data;
    } catch (error) {
      return (error as { data: { code: 0; data: null } }).data;
    }
  }
};

export const {
  getVisitRequestIdAPI,
  getVisitRequestBasicAPI,
  getVisitRequestHistoryAPI,
  getVisitRequestManagersAPI,
  getVisitRequestActionPublicAPI,
  getSendApprovedVisitorListAPI,

  postVisitRequestAPI,

  putVisitRequestIdAPI,
  putVisitRequestCancelIdAPI,
  putVisitRequestApproveIdAPI,
  putVisitRequestRejectedIdAPI
} = visitRequestAPI;
